import clsx from "clsx";
import { Button } from "../ui/Button";
import type { ButtonProps } from "../ui/Button";

export default function HeaderIconButton({ children, className, ...rest }: ButtonProps) {
  return (
    <Button
      className={clsx("hover:enabled:bg-transparent dark:hover:enabled:bg-transparent", className)}
      focusRing={false}
      minimal
      size="xs"
      {...rest}
    >
      {children}
    </Button>
  );
}
